import type { BlockAndReorderFeature } from './types';

export const newBlockReorderFunction: BlockAndReorderFeature = {
    enabled: false,
    _description: 'Enables new reorder card entry-points for lock and replace debit cards',
    addressEnabled: {
        enabled: false,
        _description: 'Displays the card delivery address in the new block reorder flow',
    },
};
